const TOP_ITEMS = [
  {
    src: "/images/przyklad-real-1.jpg",
    alt: "Widok dachu z drona — instalacja na domu jednorodzinnym",
    caption: "9,8 kWp — Dom jednorodzinny",
  },
  {
    src: "/images/przyklad-real-3.png",
    alt: "Zbliżenie paneli full black",
    caption: "Nowoczesna instalacja full black",
  },
];

const WIDE_ITEM = {
  src: "/images/przyklad-real-2.png",
  alt: "Instalacja komercyjna na długim dachu",
  caption: "42 kWp — Instalacja komercyjna",
};

export default function RealizacjeSection() {
  return (
    <section
      id="realizacje"
      className="py-12 sm:py-16 lg:py-24 bg-white"
      data-testid="realizacje-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">
            Portfolio
          </p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-ink">
            Nasze realizacje
          </h2>
          <p className="mt-4 text-lg text-brand-muted">
            Przykładowe instalacje domowe i komercyjne.
          </p>
        </div>

        {/* Top row: 2 medium cards */}
        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
          {TOP_ITEMS.map((it, idx) => (
            <figure
              key={idx}
              className="relative group"
              data-testid={`realizacja-${idx}`}
            >
              <div className="relative rounded-3xl overflow-hidden shadow-lg ring-1 ring-black/5">
                <img
                  src={it.src}
                  alt={it.alt}
                  loading="lazy"
                  className="w-full h-[240px] sm:h-[320px] lg:h-[380px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
                <div
                  aria-hidden="true"
                  className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/55 via-black/20 to-transparent"
                />
                <figcaption className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block bg-white/95 backdrop-blur-md text-brand-ink text-sm sm:text-base font-heading font-semibold px-3 py-1.5 rounded-full shadow-sm">
                    {it.caption}
                  </span>
                </figcaption>
              </div>
            </figure>
          ))}
        </div>

        {/* Bottom wide card */}
        <figure
          className="mt-4 sm:mt-5 lg:mt-6 relative group"
          data-testid="realizacja-wide"
        >
          <div className="relative rounded-3xl overflow-hidden shadow-lg ring-1 ring-black/5">
            <img
              src={WIDE_ITEM.src}
              alt={WIDE_ITEM.alt}
              loading="lazy"
              className="w-full h-[220px] sm:h-[280px] lg:h-[320px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div
              aria-hidden="true"
              className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/55 via-black/20 to-transparent"
            />
            <figcaption className="absolute bottom-4 left-4 right-4">
              <span className="inline-block bg-white/95 backdrop-blur-md text-brand-ink text-sm sm:text-base font-heading font-semibold px-3 py-1.5 rounded-full shadow-sm">
                {WIDE_ITEM.caption}
              </span>
            </figcaption>
          </div>
        </figure>
      </div>
    </section>
  );
}
